<template>
  <div>
    <b-overlay
      :show="show"
      :variant="variant"
      :opacity="opacity"
      :blur="blur"
      rounded="lg"
      spinner-variant="primary"
    >
      <div
        class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
        id="page-login"
        v-bind:style="background_image"
      >
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3 sm:m-0 m-4">
          <div class="mb-5" id="logo_image">
            <img :src="get_logo" :width="'200px'" />
          </div>
          <b-card class="mt-5">
            <form>
              <div slot="no-body" class="full-page-bg-color">
                <div class="vx-row no-gutter justify-center items-center">
                  <div
                    class="vx-col sm:w-full md:w-full lg:w-full d-theme-dark-bg"
                  >
                    <div class="p-8 login-tabs-container">
                      <div class="vx-card__title mb-4">
                        <h4 class="mb-4">{{ $t("SetPassword") }}</h4>
                      </div>
                      <div>
                        <div>
                          <label class="vs-input--label">{{
                            $t("Password")
                          }}</label>
                          <b-input-group>
                            <template #prepend>
                              <b-input-group-text>
                                <b-icon icon="lock"></b-icon>
                              </b-input-group-text>
                            </template>
                            <b-form-input
                              v-validate="
                                'required|min:8|numbers|upCase|loCase'
                              "
                              type="password"
                              name="password"
                              v-model="password"
                              ref="password"
                              :data-vv-as="$t('Password')"
                              :placeholder="$t('Password')"
                              :label="$t('Password')"
                              @keydown.enter="submitForm"
                              @input="displayError"
                            ></b-form-input>
                          </b-input-group>
                          <span
                            class="text-danger text-sm"
                            v-show="errors.has('password')"
                            >{{ errors.first("password") }}</span
                          >
                        </div>
                        <div>
                          <label class="vs-input--label">{{
                            $t("ConfirmPassword")
                          }}</label>
                          <b-input-group>
                            <template #prepend>
                              <b-input-group-text>
                                <b-icon icon="lock"></b-icon>
                              </b-input-group-text>
                            </template>
                            <b-form-input
                              v-validate="'required|confirmed:password|min:8'"
                              type="password"
                              :data-vv-as="$t('ConfirmPassword')"
                              name="confirm_password"
                              :placeholder="$t('ConfirmPassword')"
                              :label="$t('ConfirmPassword')"
                              v-model="confirm_password"
                              @keydown.enter="submitForm"
                            ></b-form-input>
                          </b-input-group>
                          <span
                            class="text-danger text-sm"
                            v-show="errors.has('confirm_password')"
                            >{{ errors.first("confirm_password") }}</span
                          >
                        </div>
                        <br />
                        <b-button
                          class="float-right"
                          variant="primary"
                          @click="submit"
                          >{{ $t("Submit") }}</b-button
                        >
                      </div>
                      <br />
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </b-card>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
// For custom error message
import { Validator } from "vee-validate";

export default {
  data() {
    return {
      password: "",
      confirm_password: "",
      showSuccess: false,
      token: "",
      logo: require("@/assets/images/logo/logo.png"),
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      sec: 2,
      counter: 0,
    };
  },
  computed: {
     get_logo() {
      return this.$store.getters.whitelabel.logo.path;
    },
    background_image(){
        return {'background-image' : "url("+this.$store.getters.whitelabel.background_image.path + ")"};
    }
 },
  watch: {
    background_image: function(newValue) {},
    get_logo: function(newValue) {},
    "$i18n.locale": {
      handler: function (value) {
        this.loadLocale(value);
        this.displayError();
      },
    },
  },
  created() {
    this.$validator.extend("upCase", {
      getMessage: () => this.$t("errorMessage"),
      validate: (value) => value.match(/[A-Z]/g) !== null,
    });
    this.$validator.extend("numbers", {
      getMessage: () => this.$t("errorMessage"),
      validate: (value) => value.match(/[0-9]/g) !== null,
    });
    this.$validator.extend("loCase", {
      getMessage: () => this.$t("errorMessage"),
      validate: (value) => value.match(/[a-z]/g) !== null,
    });
    this.token = this.$route.params.token;
    this.loadLocale(this.$i18n.locale);
  },
  methods: {
    //display error
    displayError() {
      this.$validator.extend("upCase", {
        getMessage: () => this.$t("errorMessage"),
        validate: (value) => value.match(/[A-Z]/g) !== null,
      });
      this.$validator.extend("numbers", {
        getMessage: () => this.$t("errorMessage"),
        validate: (value) => value.match(/[0-9]/g) !== null,
      });
      this.$validator.extend("loCase", {
        getMessage: () => this.$t("errorMessage"),
        validate: (value) => value.match(/[a-z]/g) !== null,
      });
    },
    //validation error message
    errorClass(rule) {
      return {
        error: this.errors.firstByRule("password", rule),
      };
    },
    /**
     * vee validate with multi lang
     */
    loadLocale(code) {
      return import("vee-validate/dist/locale/" + code).then((locale) => {
        Validator.localize(code, locale);
      });
    },
    submit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.show = true;
          this.success = "";
          this.error = "";
          var data = {
            token: this.token,
            password: this.password,
          };
          this.$store
            .dispatch("UserSetpassword", data)
            .then((response) => {
              this.show = false;
              this.$router.push({ path: "/user/login" });
              this.success = this.$t("SetPassword");
              this.$toasted.show(this.success, {
                className: "top-alert",
                position: "top-center",
                type: "success",
                duration: 2000,
              });
            })
            .catch((error) => {
              this.$log.error(
                "File : Setpassword.vue | Function : submit() | Error :",
                error
              );
              this.show = false;
              // Error response
              this.error =
                this.$t(error.replace(/[\s\/]/g, "")) !==
                error.replace(/[\s\/]/g, "")
                  ? this.$t(error.replace(/[\s\/]/g, ""))
                  : error;
              this.$toasted.show(this.error, {
                className: "top-alert",
                position: "top-center",
                type: "error",
                duration: 2000,
              });
              return false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
